<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-flex align-items-center">
      </div>
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 position-relative">
      <!-- Loader overlay pour tout le composant -->
      <div v-if="isLoadingData" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-95" style="z-index: 1000; top: 0; left: 0; min-height: 100%; border-radius: 8px;">
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Chargement...</span>
          </div>
          <h5 class="text-muted mb-2">Chargement des données...</h5>
          <p class="text-muted small">Veuillez patienter pendant que nous récupérons les informations.</p>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row">
          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field style="max-height: 42px;" v-model="motCle" name="mot" type="text" :disabled="isLoadingData"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
            </div>
          </div>

          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteur <span class="text-danger">*</span>
              </label>
              <Field name="secteur" v-model="secteur" v-slot="{ field }">
                <Multiselect :options="secteursOptions" :searchable="true" :disabled="isLoadingData" v-bind="field"
                  placeholder="Sélectionner un secteur" />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>

          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                État
              </label>
              <Multiselect 
                v-model="etatsSelectionnes" 
                :options="etatsOptions" 
                :searchable="true"
                :disabled="isLoadingData"
                placeholder="Sélectionner les états" 
              />
            </div>
          </div>
          
        </div>
      </div>
      
      <!-- Accordion pour les statistiques -->
      <div class="accordion mb-4" id="statisticsAccordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="statisticsHeader">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                    data-bs-target="#statisticsCollapse" aria-expanded="false" aria-controls="statisticsCollapse">
              <i class="flaticon-chart me-2"></i>
              Statistiques sur les arrièrés
            </button>
            <button @click="exportStatisticsAsSVG" class="btn btn-sm btn-outline-primary ms-2" 
                    title="Exporter les statistiques en SVG">
              <i class="flaticon-download me-1"></i>
              Export SVG
            </button>
          </h2>
          <div id="statisticsCollapse" class="accordion-collapse collapse" aria-labelledby="statisticsHeader" 
               data-bs-parent="#statisticsAccordion">
            <div class="accordion-body" id="statisticsContent">
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Répartition des contrats</h5>
                    </div>
                    <div class="card-body">
                      <canvas id="contratsChart" width="400" height="200"></canvas>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Résumé statistique</h5>
                    </div>
                    <div class="card-body">
                      <div class="row text-center">
                        <div class="col-6">
                          <div class="border-end">
                            <h3 class="text-success mb-1">{{ sansArrieres || 0 }}</h3>
                            <p class="text-muted mb-0">Avec arriérés payés</p>
                          </div>
                        </div>
                        <div class="col-6">
                          <h3 class="text-danger mb-1">{{ avecArrieres || 0 }}</h3>
                          <p class="text-muted mb-0">Avec arriérés impayés</p>
                        </div>
                      </div>
                      <hr>
                      <div class="text-center">
                        <h4 class="text-primary mb-1">{{ totalElements || 0 }}</h4>
                        <p class="text-muted mb-0">Total des contrats avec arrièrés payés ou non payés</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <hr>
      <div class="table-responsive">
        <!-- Message d'état vide -->
        <div v-if="!isLoadingData && contratEmplacements.length === 0" class="text-center py-5">
          <div class="mb-3">
            <i class="fas fa-search text-muted" style="font-size: 3rem;"></i>
          </div>
          <h5 class="text-muted mb-2">Aucune donnée trouvée</h5>
          <p class="text-muted">Aucun contrat ne correspond à vos critères de recherche.</p>
        </div>
        
        <table v-else class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <!-- <th class="shadow-none lh-1 fw-medium text-primary">
                    <input class="form-check-input shadow-none me-8 mt-0" type="checkbox" v-model="selectAllCheckbox">
                  <input
                        class="form-check-input shadow-none me-8 mt-0"
                        type="checkbox"
                        @click="check()"
                      />
                </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Secteur
              </th>
              <!-- <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Numéro Compte
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Ancien code
                </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nouveau Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Locataire
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Exploitant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Arriérés
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contratEmplacements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.libelle_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.ncode_emp }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (contrat.usagerLocataire) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (contrat.exploitant) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator(contrat.loyer) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator(contrat.too) }}
              </td>
              <td class="shadow-none lh-1 fw-medium pe-0">
                <span v-if="contrat.etat == 0 || contrat.etat == null" class="badge text-outline-danger">En
                  attente</span>
                <span v-else class="badge text-outline-primary">Validé</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a type="button" class="dropdown-item d-flex align-items-center" @click="ajoutArr(contrat.id)"
                        data-bs-toggle="modal" data-bs-target="#VoirDetails">
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Consulter détails
                      </a>
                    </li>
                    <li>
                      <a type="button" class="dropdown-item d-flex align-items-center" @click="ajoutArr(contrat.id)"
                        data-bs-toggle="modal" data-bs-target="#AddArrieresModal">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddArrieresModal :item="selectedItem" :type="typeT" @close="recharger" @openmodal="show_Modal" />
  <VoirDetails :item="selectedItem" :secteur="secteur" @close="recharger" @openmodal="show_Modal" />
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch, computed, watchEffect } from "vue";
import { Form, Field, ErrorMessage } from 'vee-validate';
import { hideModal, showModal, success, error, separateur, suppression, getUrlApiForFiles, downloadExcel } from '@/utils/utils';
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import Swal from 'sweetalert2';
import VoirDetails from "../ArrieresContrat/VoirDetails.vue";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import AddArrieresModal from "../Arrires/AddArrieresModal.vue";
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import axios from "axios";
import Chart from 'chart.js/auto';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default defineComponent({
  name: "EtatPlacesArrieres",
  components: {
    PaginationComponent,
    // Form,
    AddArrieresModal,
    VoirDetails,
    Field,
    Multiselect,

  },
  setup: () => {
    const contrats = ref<Array<Contrat>>([]);
    const contrat = ref<Contrat>();
    const selectedItem = ref(0);
    const secteur = ref("")
    const typeT = ref("Modification")
    const etat = ref('0');

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const etatsOptions = ref<Array<Option>>([
      { label: 'Sans arriérés', value: '1', disabled: false },
      { label: 'Avec arriérés', value: '2', disabled: false }
    ]);
    const etatsSelectionnes = ref<string>("0");
    const motCle = ref('');
    const checkboxes = ref<Array<boolean>>([]);
    const selectAllCheckbox = ref(false);
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    function formatWithThousandSeparator(num: string): string {
      const num2 = parseFloat(num);
      return num2.toLocaleString("fr-FR");
    }

    const ajoutArr = (id: number) => {
      selectedItem.value = id;
    };

    watch(selectAllCheckbox, (newValue, oldValue) => {
      if (newValue != oldValue) {
        selectAllCheckbox.value = newValue;
        for (let i = 0; i < checkboxes.value.length; i++) {
          checkboxes.value[i] = newValue;
        }
      }
    });
    const selectAll = ref(false);
    const selectedContracts = ref(false);

    function handleSelectAll() {
      if (selectAll.value) {
        // selectedContracts.value = contratEmplacements.value.map(contrat => contrat?.id);
      } else {
        // selectedContracts.value = [];
      }
    }
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const recupereSecteurs = async () => {
      try {
        const response = await axios.get('/secteur');
        const donneee = response.data.data;
        secteursOptions.value = donneee.map((secteur) => ({
          label: `${secteur.code_secteur} -- [ ${secteur.libelle_secteur} ]`,
          value: secteur.code_secteur,
          disabled: false
        }));
        return secteursOptions.value;
      } catch (error) {
        //
      }
    }
    const contratEmplacements = ref([]);

    const actionRecherche = async (page = 1, limi = 10, searchTerm = '') => {
      // if(secteur.value == ''){
      //   error("Veuillez selectionnez un secteur")
      //   return;
      // }else{
      isLoadingData.value = true;
      const element = {
        secteur: secteur.value,
        motCle: motCle.value,
        etats: etatsSelectionnes.value,
        etat: etat.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm
      };
        try {
          const response = await axios.post('/etats/places-arrieres/liste', element);
          contratEmplacements.value = response.data.data.data;
          totalPages.value = response.data.data.totalPages;
          limit.value = response.data.data.limit;
          totalElements.value = response.data.data.totalElements;
          
          // Récupérer les statistiques
          avecArrieres.value = parseInt(response.data.data.avecArrieres) || 0;
          sansArrieres.value = parseInt(response.data.data.sansArrieres) || 0;
          
          // Mettre à jour le graphique
          updateChart();
          
          //return  contratEmplacements.value;
          for (let i = 0; i < contratEmplacements.value.length; i++) {
            checkboxes.value.push(false)
          }
        } catch (error) {
          //
        } finally {
          isLoadingData.value = false;
        }
      // }

    }
    watch(secteur, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      secteur.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    watch(motCle, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    watch(etatsSelectionnes, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      etat.value = newValue || '0';
      etatsSelectionnes.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    onMounted(() => {
      recupereSecteurs();
      actionRecherche(1, 10);
    });

    const checkedItems = ref<Array<number>>([]); // Tableau pour suivre les éléments cochés
    
    // Variables pour l'export
    const valideEtape3 = ref(true);
    const isLoading = ref(false);
    
    // Variable pour le chargement des requêtes
    const isLoadingData = ref(false);
    
    // Variables pour les statistiques
    const avecArrieres = ref(0);
    const sansArrieres = ref(0);
    let chartInstance: any = null;

    const handleChange = (id: number) => {
      if (checkedItems.value.includes(id)) {
        checkedItems.value.splice(checkedItems.value.indexOf(id), 1);
      } else {
        checkedItems.value.push(id);
      }
    }
    const vider = () => {
      checkedItems.value = [];
      page.value = 1;
      selectAll.value = false;
    }
    const soumission = async () => {
      const result = await Swal.fire({
        text: `Vous êtes sur le point de valider les arrièrés de ce secteur. Continuer ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: `Non`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      if (result.isConfirmed) {
        var values = {};
        values["contrats"] = checkedItems.value;
        values["secteur"] = secteur.value;
        values["etat"] = true;
        await ApiService.post("/validation", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              actionRecherche(page.value, limit.value);
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
            vider();
          });
      }

    };

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
          secteur: secteur.value,
          etat: etatsSelectionnes.value,
        };
        
        // Utiliser ApiService au lieu d'axios directement pour avoir l'authentification
        ApiService.setHeader(); // S'assurer que les en-têtes d'authentification sont configurés
        const response = await ApiService.post("/etats/places-arrieres/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openNewWindow({ reference: (response.data.data) }, "Excel");
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Excel") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".xlsx"));
    }

    // Fonction pour créer et mettre à jour le graphique
    const updateChart = () => {
      const ctx = document.getElementById('contratsChart') as HTMLCanvasElement;
      if (!ctx) return;

      // Détruire l'instance précédente si elle existe
      if (chartInstance) {
        chartInstance.destroy();
      }

      chartInstance = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Avec arriérés payés', 'Avec arriérés impayés'],
          datasets: [{
            data: [sansArrieres.value, avecArrieres.value],
            backgroundColor: [
              '#28a745', // Vert pour sans arriérés
              '#dc3545'  // Rouge pour avec arriérés
            ],
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                padding: 20,
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((context.parsed / total) * 100).toFixed(1);
                  return `${context.label}: ${context.parsed} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    };

    // Fonction pour exporter les statistiques en SVG
    const exportStatisticsAsSVG = async () => {
      try {
        // Ouvrir l'accordion si il est fermé
        const collapseElement = document.getElementById('statisticsCollapse');
        if (collapseElement && !collapseElement.classList.contains('show')) {
          const bsCollapse = new (window as any).bootstrap.Collapse(collapseElement, { show: true });
          await new Promise(resolve => setTimeout(resolve, 500)); // Attendre l'ouverture
        }

        // Attendre que le graphique soit rendu
        await new Promise(resolve => setTimeout(resolve, 1000));

        const element = document.getElementById('statisticsContent');
        if (!element) {
          error('Élément des statistiques non trouvé');
          return;
        }

        // Utiliser html2canvas pour capturer l'élément
        const canvas = await html2canvas(element, {
          backgroundColor: '#ffffff',
          scale: 2, // Améliorer la qualité
          useCORS: true,
          allowTaint: true
        });

        // Convertir en SVG
        const svgData = canvas.toDataURL('image/png');
        
        // Créer un lien de téléchargement
        const link = document.createElement('a');
        link.download = `statistiques_arrieres_${new Date().toISOString().split('T')[0]}.png`;
        link.href = svgData;
        link.click();

        success('Statistiques exportées avec succès !');
      } catch (err) {
        console.error('Erreur lors de l\'export:', err);
        error('Erreur lors de l\'export des statistiques');
      }
    };


    return {
      checkedItems,
      contrats,
      checkboxes,
      suppression,
      selectedItem,
      recharger,
      show_Modal,
      page,
      secteur,
      selectAllCheckbox,
      secteursOptions,
      etatsOptions,
      etatsSelectionnes,
      totalPages,
      limit,
      selectAll,
      handleSelectAll,
      formatWithThousandSeparator,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      soumission,
      handleChange,
      contratEmplacements,
      typeT,
      ajoutArr,
      telecharger,
      valideEtape3,
      isLoading,
      isLoadingData,
      openNewWindow,
      avecArrieres,
      sansArrieres,
      updateChart,
      exportStatisticsAsSVG
    };
  },
});
</script>

<style scoped>
/* Amélioration du loader overlay pour tout le composant */
.position-relative .position-absolute {
    backdrop-filter: blur(3px);
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Animation fade pour le contenu */
.table {
    transition: opacity 0.3s ease-in-out;
}

/* Style pour le message d'état vide */
.text-center.py-5 {
    background-color: #f8f9fa;
    border-radius: 8px;
    margin: 20px 0;
}

/* Amélioration des champs désactivés */
.form-control:disabled,
.multiselect.is-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Animation pour le loader principal */
.spinner-border {
    animation: spinner-border 0.75s linear infinite;
}

/* Effet de pulsation pour le texte du loader */
@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.7; }
    100% { opacity: 1; }
}

.text-muted {
    animation: pulse 2s ease-in-out infinite;
}
</style>
